import React from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as TransportIcon} from 'assets/svg/transport-code.svg';
import {ReactComponent as UnitIcon} from 'assets/svg/unit-code.svg';

import {Icon} from 'components/ui-kit/Icon';

import {BannerDescription, BannerSection, BannerTitle, Wrapper} from './styled';

interface InvoiceLineTypeBannerProps {
    type: 'unit' | 'transport' | null;
}

export const InvoiceLineTypeBanner = ({type}: InvoiceLineTypeBannerProps) => {
    const {t} = useTranslation();
    return (
        <Wrapper $type={type}>
            <BannerSection>
                <Icon
                    fillColor="transparent"
                    width={24}
                    height={24}
                    source={type === 'unit' ? UnitIcon : TransportIcon}
                />
            </BannerSection>
            <BannerSection>
                <BannerTitle>
                    {type === 'unit'
                        ? t('pages.documents.invoices.create.banner.unit.title')
                        : t('pages.documents.invoices.create.banner.transport.title')}
                </BannerTitle>
                {type === 'unit' && (
                    <BannerDescription>
                        {t('pages.documents.invoices.create.banner.unit.description')}
                    </BannerDescription>
                )}
            </BannerSection>
        </Wrapper>
    );
};
